const KeyMirror = require('keymirror');

module.exports = KeyMirror({
    GET_CATEGORIES_BEGIN: true,
    GET_CATEGORIES_SUCCESS: true,
    GET_CATEGORIES_ERROR: true,
});
